export const clear_phone_format = (phone_number)=>{
    return phone_number.replace(/[\s+\-\(\)]/g,'');
}